<mat-card *ngIf="stats" class="backspace cursor title">
    <mat-card-title class="statsbg">Turn Over {{year}}</mat-card-title>
    <div style="width: 100%; height: 200px; overflow: hidden;">
        <ngx-charts-bar-vertical-stacked  
            [results]="stats.statChart"
            [gradient]="gradient" 
            [xAxis]="showXAxis" 
            [yAxis]="showYAxis" 
            [legend]="showLegend"
            [showXAxisLabel]="showLegend" 
            [showYAxisLabel]="showLegend" 
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel" 
            [animations]="animations" 
            [customColors]="customColors">
        </ngx-charts-bar-vertical-stacked>
    </div>
</mat-card>